import { defineMessages } from '@jutro/locale';

export default defineMessages({
    Claims: {
        id: 'ml.claim.views.claims.Claims',
        defaultMessage: 'Claims'
    },
    pageSubtitle: {
        id: 'ml.claim.views.claims.One simple place to check on, review, and file your claims',
        defaultMessage: 'One simple place to check on, review, and file your claims'
    },
    NoPriorClaimsExist: {
        id: 'ml.claim.views.claims.No prior claims exist',
        defaultMessage: 'No prior claims exist'
    },
    YourClaims: {
        id: 'ml.claim.views.claims.Your Claims',
        defaultMessage: 'Your Claims'
    },
    NewClaimToReport: {
        id: 'ml.claim.views.claims.Do you have a new claim to report?',
        defaultMessage: 'Do you have a new claim to report?'
    },
    FileAClaim: {
        id: 'ml.claim.directives.claim-summary.File a Claim',
        defaultMessage: 'File a Claim'
    },
    FileAClaimTwoHours: {
        id: 'ml.claim.views.claims.You have up to two hours to finish filing your claim from the time you begin',
        defaultMessage: 'You have up to two hours to finish filing your claim from the time you begin.'
    },
    IncludeInformation: {
        id: 'ml.claim.views.claims.Include the following information, if available:',
        defaultMessage: 'Include the following information, if available:'
    },
    ContactInformation: {
        id: 'ml.claim.views.claims.Names and contact information of any other people who were involved',
        defaultMessage: 'Names and contact information of any other people who were involved'
    },
    PoliceInformation: {
        id: 'ml.claim.views.claims.Name of responding police or fire department and the report number',
        defaultMessage: 'Name of responding police or fire department and the report number'
    },
    PhotoInformation: {
        id: 'ml.claim.views.claims.Photos, receipts, estimates or any other documents that may help us process your claim faster',
        defaultMessage: 'Photos, receipts, estimates or any other documents that may help us process your claim faster'
    },
    WhatHappensNext: {
        id: 'ml.claim.views.claims.What happens next after you submit a claim:',
        defaultMessage: 'What happens next after you submit a claim:'
    },
    ClaimConsultantAssigned: {
        id: 'ml.claim.views.claims.A Claim Consultant will be assigned and will contact you within one business day',
        defaultMessage: 'A Claim Consultant will be assigned and will contact you within one business day'
    },
    ClaimConsultantAdditionalInfo: {
        id: 'ml.claim.views.claims.The Claim Consultant will discuss your claim with you and may request additional information including:',
        defaultMessage: 'The Claim Consultant will discuss your claim with you and may request additional information including:'
    },
    InsuranceInformation: {
        id: 'ml.claim.views.claims.Insurance information for the other vehicle(s) involved in the accident',
        defaultMessage: 'Insurance information for the other vehicle(s) involved in the accident'
    },
    PoliceInformation2: {
        id: 'ml.claim.views.claims.Name of the responding police or fire department and the report number',
        defaultMessage: 'Name of the responding police or fire department and the report number'
    },
    claimError: {
        id: 'ml.claim.views.claims.Were sorry – our system is unable to retrieve your claim history at this time',
        defaultMessage: 'We\'re sorry – our system is unable to retrieve your claim history at this time'
    }
});
